
import store from '@/store';
import track from '@/store/modules/track';
import userManager from '@/user-manager';
import { UserDto, UserDtoMemberLevelTypeEnum } from '@chainsight/networker-backend-axios-sdk';
import Vue from 'vue'

export default Vue.extend({
    name: 'AvatarMenu',
    data() {
        return {
           userDto: {} as UserDto,
           UserDtoMemberLevelTypeEnum,
           showFeedbackDialog: false,
           feedbackText: ''
        }
    },
    computed: {
        user() {
            return store.state.user;
        },
        blobBaseUrl() {
            return process.env.VUE_APP_BLOB_API_BASE_URL;
        },
        daysLeft(): number {
            if (!this.userDto.paidMemberExpiredAt) return 0;
            const now = new Date();
            const expiredAt = new Date(this.userDto.paidMemberExpiredAt);
            const diffTime = expiredAt.getTime() - now.getTime();
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays > 0 ? diffDays : 0;
        },
        trackDto(){
            return store.state.track.trackDto
        },
    },
    methods: {
        signOut() {
            userManager.signoutRedirect();
        },
        async getMe() {
            let getMeResp
            try{
                getMeResp = await this.api$.authApi.getMe()
                this.userDto = getMeResp.data.data
                // this.userDto.isPaidMember = true
                // this.userDto.memberLevelType = UserDtoMemberLevelTypeEnum.Premium
            }catch (error) {
                console.error(error)
            }
        },
        submitFeedback() {
            if (!this.feedbackText.trim()) {
                return;
            }
            // TODO: 實作提交反饋的 API 呼叫
            console.log('Feedback submitted:', this.feedbackText);
            this.showFeedbackDialog = false;
            this.feedbackText = '';
        }
    },
    async created(){
        await this.getMe()
    },
    mounted(){
		this.eventHub$.$on('avatarMenuGetUser', () => {
			this.getMe()
		})
	},
	beforeDestroy(){
		this.eventHub$.$off('avatarMenuGetUser')
	}
});
